import React, { useState } from 'react'
import StepForm from './StepForm';

//currently used

export default function Calculator(props) {
    const [dataArray, setDataArray] = useState({
        totalDebt: '',
        estimateDebt: '',
        taxDebtType: "",
        taxDebtKind: "",
        grossMonthlyIncome: "",
        enrollmentPlan:"",
        creditScore: "",
        unfiledTaxReturns: "",
        firstName: "",
        lastName: "",
        email: "",
        cellPhone: "",
        description:"",
        agree: false,
        optIn: false
    })

    const updateFieldValue = (name, value) => {
        let newDataArray = { ...dataArray };
        newDataArray[name] = value
        setDataArray(newDataArray)
        // console.log("update", name, value)
    }

    return (
        <div>
            <StepForm dataArray={dataArray} updateFieldValue={updateFieldValue} />
        </div>
    );
}
